import React from 'react';
import c from 'classnames';

import { CoreLink } from '@uncinc/react-drupal-core';

import Card from '../Card';
import { GenericCardProps } from '../Card/types';
import Tag from '../Tag';

import './style.scss';

const GenericCard: React.FC<GenericCardProps> = (props) => {
  const {
    title,
    tags,
    image,
    subtitle,
    link,
    className,
    profile,
  } = props;

  const classNames = c('GenericCard', 'u-focus-ring--within', 'u-link-box', className);

  return (
    <Card className={classNames}>
      {(tags && tags.length > 0) && (
        <div className="GenericCard__tags">
          {tags.map((tag, index) => (
            <Tag
              key={`tag:${tag.type}:${index + 1}`}
              type={tag.type}
              name={tag.name}
            />
          ))}
        </div>
      )}

      <Card.Content>
        <CoreLink to={link}>
          <Card.Title title={title} />
        </CoreLink>

        <Card.Subtitle subtitle={subtitle} />

        <Card.Profile profile={profile} />
      </Card.Content>

      <Card.Image image={image} />
    </Card>
  );
};

export default GenericCard;
